(function () {
    // Store original prices in PKR to prevent data corruption
    const originalPrices = new Map();

    document.addEventListener('click', function (e) {
      const link = e.target.closest('.sr4-pr-color-link');
      if (!link) return;

      e.preventDefault();

      const variantPrice = link.getAttribute('data-variant-price');
      const variantComparePrice = link.getAttribute('data-variant-compare-price');
      const productId = link.getAttribute('data-product-id');
      const variantId = link.getAttribute('data-variant-id');

      // Store original PKR prices
      if (!originalPrices.has(variantId)) {
        originalPrices.set(variantId, {
          price: variantPrice,
          comparePrice: variantComparePrice
        });
      }

      const productCard = link.closest('.sr4-product') || link.closest('.sr4-product-wrapper') || link.closest('[class*="product"]');
      
      let priceContainer;
      if (productCard) {
        priceContainer = productCard.querySelector(`[data-product-price-container="${productId}"]`);
      }
      
      if (!priceContainer) {
        priceContainer = document.querySelector(`[data-product-price-container="${productId}"]`);
      }

      if (!priceContainer) {
        console.warn('Price container not found for product:', productId);
        return;
      }

      updatePriceDisplay(priceContainer, variantPrice, variantComparePrice, productCard);
      updateActiveColorState(link);
      updateProductImage(link);
    });

    function updatePriceDisplay(container, price, comparePrice, wrapper) {
      // Clear existing price elements
      container.querySelectorAll(
        '.price, .price--sale, .price-item, .price-item--regular, .price-item--sale, sr4-product-price'
      ).forEach(el => el.remove());

      const currentCurrency = localStorage.T4Currency || 'PKR';
      let priceHTML = '';

      if (comparePrice) {
        priceHTML = `
          <div class="price price--sale" data-base-price="${price}" data-base-compare="${comparePrice}">
            <span class="price-item price-item--regular">
              ${createCurrencySpan(comparePrice, currentCurrency)}
            </span>
            <span class="price-item price-item--sale">
              ${createCurrencySpan(price, currentCurrency)}
            </span>
          </div>
        `;

        // Update sale badge
        updateSaleBadge(wrapper, price, comparePrice);
      } else {
        priceHTML = `
          <div class="price" data-base-price="${price}">
            <span class="price-item">
              ${createCurrencySpan(price, currentCurrency)}
            </span>
          </div>
        `;

        // Hide sale badge
        const saleBadge = wrapper?.querySelector('.sr4-badge-sale');
        if (saleBadge) saleBadge.style.display = 'none';
      }

      container.innerHTML = priceHTML;

      // Apply currency conversion
      requestAnimationFrame(() => {
        if (window.Currency?.convertAll) {
          Currency.convertAll('PKR', currentCurrency);
        }
      });
    }

    function updateSaleBadge(wrapper, price, comparePrice) {
      if (!wrapper) return;
      
      const saleBadge = wrapper.querySelector('.sr4-badge-sale');
      if (!saleBadge) return;

      const p = parseFloat(price.replace(/[^\d.]/g, ''));
      const c = parseFloat(comparePrice.replace(/[^\d.]/g, ''));
      
      if (c > p) {
        const discount = Math.round(((c - p) / c) * 100);
        saleBadge.textContent = `${discount}% OFF`;
        saleBadge.style.display = 'inline-flex';
      } else {
        saleBadge.style.display = 'none';
      }
    }

    function createCurrencySpan(priceString, currency) {
      const value = parseFloat(priceString.replace(/[^\d.]/g, ''));
      if (isNaN(value)) return '';

      // For base currency (PKR), show original value
      let displayValue = value;
      
      // Only convert if not PKR
      if (currency !== 'PKR' && window.Currency?.convert) {
        displayValue = Currency.convert(value, 'PKR', currency);
      }

      const amount = Math.round(displayValue).toLocaleString();
      const symbols = { USD: '$', PKR: 'PKR', EUR: '€', GBP: '£', AED: 'Dhs.' };
      const symbol = symbols[currency] || currency;
      const spacer = ['USD', 'EUR', 'GBP'].includes(currency) ? '' : ' ';

      return `<span class="money" data-currency-${currency}="${amount}">${symbol}${spacer}${amount}</span>`;
    }

    function updateActiveColorState(link) {
      const productCard = link.closest('.sr4-product') || link.closest('.sr4-product-wrapper');
      const wrap = productCard?.querySelector('.flickitysr4') || link.closest('.flickitysr4');
      
      if (!wrap) return;

      wrap.querySelectorAll('.sr4-pr-color-link').forEach(el => {
        el.classList.remove('active');
        el.closest('.sr4-pr-color__item')?.classList.remove('active');
      });

      link.classList.add('active');
      link.closest('.sr4-pr-color__item')?.classList.add('active');
    }

    function updateProductImage(link) {
      const product = link.closest('.sr4-product');
      if (!product) return;

      const imageUrl = link.dataset.variantImage;
      const variantId = link.dataset.variantId;
      const productImg = product.querySelector('.sr4-product-img img');
      const productLink = product.querySelector('a[data-pr-href]');

      // Remove active swatch
      product.querySelectorAll('.sr4-pr-color__item')
        .forEach(item => item.classList.remove('selected-swatch'));

      // Add active swatch
      const swatch = link.querySelector('.sr4-pr-color__item');
      if (swatch) swatch.classList.add('selected-swatch');

      // Update image
      if (imageUrl && productImg) {
        const img = new Image();
        img.onload = () => {
          productImg.src = imageUrl;
          productImg.srcset = imageUrl;
          productImg.dataset.src = imageUrl;
          productImg.classList.remove('lazyloadsr4ed');
        };
        img.src = imageUrl;
      }

      // Update product URL
      if (productLink && variantId) {
        const baseUrl = productLink.href.split('?')[0];
        productLink.href = `${baseUrl}?variant=${variantId}`;
      }
    }

    function autoSelectFirstColor() {
      document.querySelectorAll('.sr4-product').forEach(productCard => {
        const firstColor = productCard.querySelector('.sr4-pr-color-link.is-default-color');

        if (firstColor && !firstColor.classList.contains('auto-selected')) {
          firstColor.classList.add('auto-selected');
          firstColor.dispatchEvent(new Event('click', { bubbles: true }));
        }
      });
    }

    // Listen for currency changes and refresh prices
    function handleCurrencyChange() {
      const currentCurrency = localStorage.T4Currency || 'PKR';
      
      document.querySelectorAll('[data-product-price-container]').forEach(container => {
        const priceEl = container.querySelector('.price');
        if (!priceEl) return;

        const basePrice = priceEl.dataset.basePrice;
        const baseCompare = priceEl.dataset.baseCompare;
        
        if (!basePrice) return;

        const wrapper = container.closest('.sr4-product-wrapper') || container.closest('.sr4-product');
        
        // Re-render with base prices
        updatePriceDisplay(container, basePrice, baseCompare || null, wrapper);
      });
    }

    // Watch for currency changes
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'T4Currency') {
        setTimeout(handleCurrencyChange, 100);
      }
    };

    // Initial runs
    setTimeout(autoSelectFirstColor, 300);
    setTimeout(autoSelectFirstColor, 800);

    // Watch for dynamically added products
    const observer = new MutationObserver(function(mutations) {
      let shouldProcess = false;
      
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('sr4-product') || 
                node.querySelector?.('.sr4-product')) {
              shouldProcess = true;
            }
          }
        });
      });

      if (shouldProcess) {
        setTimeout(autoSelectFirstColor, 100);
      }
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }

    // Trigger on common events
    document.addEventListener('shopify:section:load', () => setTimeout(autoSelectFirstColor, 100));
    document.addEventListener('recentlyViewedLoaded', () => setTimeout(autoSelectFirstColor, 100));
    
    // Handle currency switcher clicks
    document.addEventListener('click', function(e) {
      if (e.target.closest('.currency-selector') || e.target.closest('[data-currency]')) {
        setTimeout(handleCurrencyChange, 200);
      }
    });

})();

// 
document.addEventListener("click", e => {
const link = e.target.closest(".sr4-pr-color-link");
if (!link) return;

e.preventDefault();

const product = link.closest(".sr4-product");
if (!product) return;

const imageUrl  = link.dataset.variantImage;
const variantId = link.dataset.variantId;

const productImg  = product.querySelector(".sr4-product-img img");
const productLink = product.querySelector("a[data-pr-href]");

// Remove active swatch
product.querySelectorAll(".sr4-pr-color__item")
    .forEach(item => item.classList.remove("selected-swatch"));

// Add active swatch
const swatch = link.querySelector(".sr4-pr-color__item");
if (swatch) swatch.classList.add("selected-swatch");

// Update image
if (imageUrl && productImg) {
    const img = new Image();
    img.onload = () => {
    productImg.src = imageUrl;
    productImg.srcset = imageUrl;
    productImg.dataset.src = imageUrl;
    productImg.classList.remove("lazyloadsr4ed");
    };
    img.src = imageUrl;
}

// Update product URL
if (productLink && variantId) {
    const baseUrl = productLink.href.split("?")[0];
    productLink.href = `${baseUrl}?variant=${variantId}`;
}
});